import type { JsonApiResponse } from 'json-api-normalizer';

import api from 'api/apiInstance';

export function practiceAdminsExportListApi(path: string) {
  return {
    path,
    GET: () => api.get<JsonApiResponse>(path),
  };
}
